import axios from "axios";

// Apps page: load the modules, switch one on or off
export default {
   methods: {
      fetchModules() {
         // Show the page loader (PageStatus)
         this.tableData.loaderMessage = this.$loaderMessages.loaderMessageDefault;
         this.tableData.isVisible = true;

         axios
            .get(`${this.apiUrl}?action=fetchModules`, this.$handleConfig())
            .then((response) => {
               if (response.data.status === "success") {
                  this.handleFetchModulesSuccess(response);
               } else {
                  this.handleAlert("ending", response.data.message, "danger", "page");
               }
            })
            .catch((error) => this.handleModulesRequestError(error))
            .finally(() => {
               this.tableData.isVisible = false;
               this.modulesLoaded = true;
            });
      },
      handleFetchModulesSuccess(response) {
         this.modules = response.data.results.modules || [];
         this.canManage = !!response.data.results.can_manage;
         this.isDeveloper = !!response.data.results.is_developer;
         this.rolePermissions = response.data.results.role_permissions || [];
      },
      // Works out the menu from the switches on this page, straight away (no waiting for the server)
      applyMenuNow() {
         const selectable = this.modules.filter((module) => module.module_type === "selectable");

         if (this.isDeveloper) {
            this.$store.commit("SET_MODULES", selectable.map((module) => module.module_key));
            this.$store.commit("SET_PERMISSIONS", this.rolePermissions);
            return;
         }

         const enabled = selectable.filter((module) => module.is_enabled).map((module) => module.module_key);

         // Permissions of the modules that are off
         const blocked = selectable
            .filter((module) => !module.is_enabled)
            .flatMap((module) => String(module.permission_prefixes || "").split(","))
            .map((prefix) => prefix.trim())
            .filter(Boolean);

         this.$store.commit("SET_MODULES", enabled);
         this.$store.commit(
            "SET_PERMISSIONS",
            this.rolePermissions.filter((key) => !blocked.some((prefix) => String(key).startsWith(prefix)))
         );
      },
      toggleModule(module, turnOn) {
         if (!this.canManage) return;
         this.saving = module.module_key;

         // The menu changes at once; it goes back below if the save fails
         const previousModules = [...(this.$store.state.modules || [])];
         const previousPermissions = [...(this.$store.state.permissions || [])];
         module.is_enabled = turnOn;
         this.applyMenuNow();

         // Save failed: switch and menu back to how they were
         const undo = () => {
            module.is_enabled = !turnOn;
            this.$store.commit("SET_MODULES", previousModules);
            this.$store.commit("SET_PERMISSIONS", previousPermissions);
         };

         const formData = new FormData();
         formData.append("action", "saveModule");
         formData.append("module_key", module.module_key);
         formData.append("enabled", turnOn ? 1 : 0);

         axios
            .post(this.apiUrl, formData, this.$handleConfig())
            .then((response) => {
               if (response.data.status === "success") {
                  this.handleSaveModuleSuccess(module, turnOn, response);
               } else {
                  undo();
                  this.handleAlert("ending", response.data.message, "danger", "page");
               }
            })
            .catch((error) => {
               undo();
               this.handleModulesRequestError(error);
            })
            .finally(() => {
               this.saving = "";
            });
      },
      // The switch itself shows the result (green = on, grey = off); the menu follows at once
      handleSaveModuleSuccess(module, turnOn, response) {
         module.is_enabled = turnOn;
         this.$store.commit("SET_MODULES", response.data.results.modules || []);
         // New permissions too (e.g. Samples' pages come back), so no new login is needed
         if (Array.isArray(response.data.results.permissions)) {
            this.$store.commit("SET_PERMISSIONS", response.data.results.permissions);
         }
      },
      handleModulesRequestError(error) {
         if (error && error.message === "Network Error") {
            this.handleAlert("ending", "No internet connection. Please check your network.", "danger", "page");
         } else {
            this.handleAlert("ending", "Something went wrong. Please try again later.", "danger", "page");
         }
      },
   },
};